import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '../../lib/utils';

// Parse content and make hashtags clickable
export const HashtagText = ({ content, className }) => {
  if (!content) return null;

  // Split content by hashtags while keeping them
  const parts = content.split(/(#\w+)/g);

  return (
    <span className={cn("whitespace-pre-wrap", className)}>
      {parts.map((part, index) => {
        if (part.startsWith('#')) {
          const hashtag = part.slice(1).toLowerCase();
          return (
            <Link
              key={index}
              to={`/explore/hashtag/${hashtag}`}
              className="text-primary hover:underline font-medium"
              onClick={(e) => e.stopPropagation()}
              data-testid={`hashtag-${hashtag}`}
            >
              {part}
            </Link>
          );
        }
        return <span key={index}>{part}</span>;
      })}
    </span>
  );
};

// Hashtag chip for trending
export const HashtagChip = ({ hashtag, count, onClick }) => (
  <button
    onClick={onClick}
    className="flex items-center gap-2 px-4 py-2 rounded-full bg-secondary hover:bg-secondary/80 transition-colors"
    data-testid={`trending-hashtag-${hashtag}`}
  >
    <span className="text-primary font-semibold">#{hashtag}</span>
    {count && <span className="text-sm text-muted-foreground">{count} posts</span>}
  </button>
);

// Trending hashtags list
export const TrendingHashtags = ({ hashtags, onSelect }) => {
  if (!hashtags || hashtags.length === 0) return null;

  return (
    <div className="space-y-2">
      <h3 className="font-semibold text-sm text-muted-foreground px-4">Hashtags Popilè</h3>
      <div className="flex flex-wrap gap-2 px-4">
        {hashtags.slice(0, 10).map((item) => (
          <HashtagChip
            key={item.hashtag}
            hashtag={item.hashtag}
            count={item.count}
            onClick={() => onSelect?.(item.hashtag)}
          />
        ))}
      </div>
    </div>
  );
};

export default HashtagText;
